import React from "react";
import footerbg from "../../assets/img/footer-background.png";
import xicon from "../../assets/img/xicon.png";

const DashboardFooter = () => {
  return (
    <footer style={{ width: '100%', position: 'relative', zIndex: 5, marginTop: 'auto', display: 'flex', flexDirection: 'column', flexShrink: 0, background: '#fff', boxSizing: 'border-box' }}>
      <div className="dashboard-footer-main" style={{
        width: '100%',
        background: `url(${footerbg}) repeat, #fff`,
        color: '#111',
        padding: '32px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        borderTop: '2px solid #eee',
        marginTop: 0,
        minHeight: 150,
        position: 'relative',
        overflow: 'hidden',
      }}>
          <div className="dashboard-footer-cols" style={{
            width: '100%',
            maxWidth: 1200,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 32,
            marginBottom: 32,
            flexWrap: 'wrap',
            // --- ADDED: Base horizontal padding for all screens ---
            padding: '0 32px',
          }}>
            {/* Legal */}
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontWeight: 700, fontSize: 'clamp(16px, 4vw, 18px)', marginBottom: 20, color: '#111' }}>Legal</div>
              <a href="https://www.oldmutual.com.gh/disclaimer/" target="_blank" rel="noopener noreferrer" style={{ display: 'none' }}>Disclaimer</a>
              <a href="https://www.oldmutual.com.gh/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ fontSize: 'clamp(14px, 3.5vw, 15px)', opacity: 0.85, color: '#111', marginBottom: 10, display: 'block', textDecoration: 'none' }}>Privacy Policy</a>
              <a href="https://www.oldmutual.com.gh/secure-services-terms-and-conditions/" target="_blank" rel="noopener noreferrer" style={{ fontSize: 'clamp(14px, 3.5vw, 15px)', opacity: 0.85, color: '#111', marginBottom: 0, display: 'block', textDecoration: 'none' }}>Terms and Conditions</a>
            </div>
            {/* Download App */}
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontWeight: 700, fontSize: 'clamp(16px, 4vw, 18px)', marginBottom: 20, color: '#111' }}>Download Old Mutual App</div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 8, alignItems: 'flex-start' }}>
                <a href="https://apps.apple.com/us/app/old-mutual/id1481355805" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', fontSize: 'clamp(16px, 4vw, 18px)', alignItems: 'center', gap: 6, color: '#111', textDecoration: 'none' }}>
                  <i className="bi bi-apple footer-link-icon" style={{ fontSize: 'clamp(20px, 5vw, 22px)', color: '#111' }} />
                 Apple Store
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.oldmutual.myoldmutual" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ display: 'flex', fontSize: 'clamp(16px, 4vw, 18px)', alignItems: 'center', gap: 6, color: '#111', textDecoration: 'none' }}>
                  <i className="bi bi-android2 footer-link-icon" style={{ fontSize: 'clamp(20px, 5vw, 22px)', color: '#111' }} />
                  Play Store
                </a>
              
              </div>
            </div>
            {/* Social Media */}
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontWeight: 700, fontSize: 'clamp(16px, 4vw, 18px)', marginBottom: 20, color: '#111' }}>Social Media</div>
              <div style={{ display: 'flex', gap: 32 }}>
                {/* Column 1 */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  <a href="https://www.facebook.com/OLDMUTUALGHANALTD/" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ color: '#111', fontSize: 'clamp(16px, 4vw, 18px)', background: 'none', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                    <i className="bi bi-facebook footer-link-icon" style={{ fontSize: 'clamp(20px, 5vw, 22px)', color: '#111' }} />
                    Facebook
                  </a>
                  <a href="https://www.youtube.com/channel/UCn7mdlqxJeAuzy32mDpYevA" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ color: '#111', fontSize: 'clamp(16px, 4vw, 18px)', background: 'none', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                    <i className="bi bi-youtube footer-link-icon" style={{ fontSize: 'clamp(20px, 5vw, 22px)', color: '#111' }} />
                    YouTube
                  </a>
                    <a href="https://www.linkedin.com/company/old-mutual-gh" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ color: '#111', fontSize: 'clamp(16px, 4vw, 18px)', background: 'none', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                    <i className="bi bi-linkedin footer-link-icon" style={{ fontSize: 'clamp(20px, 5vw, 22px)', color: '#111' }} />
                    LinkedIn
                  </a>
                </div>
                {/* Column 2 */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                 <a
  href="https://twitter.com/oldmutual_gh?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
  target="_blank"
  rel="noopener noreferrer"
  className="footer-link"
  style={{
    color: '#111',
    fontSize: 'clamp(16px, 4vw, 18px)',
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    textDecoration: 'none',
  }}
>
  <img
    src={xicon}
    alt="X (Twitter)"
    style={{ width: 'clamp(20px, 5vw, 22px)', height: 'clamp(20px, 5vw, 22px)' }}
  />
  <span>X (Formerly Twitter)</span>
</a>

                  <a href="https://www.instagram.com/oldmutualghana/" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ color: '#111', fontSize: 'clamp(16px, 4vw, 18px)', background: 'none', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
                    <i className="bi bi-instagram footer-link-icon" style={{ fontSize: 'clamp(20px, 5vw, 22px)', color: '#111' }} />
                    Instagram
                  </a>
                
                </div>
              </div>
            </div>
          </div>
          <style>{`
            @media (max-width: 900px) {
              .dashboard-footer-cols {
                flex-direction: column;
                gap: 24px;
                align-items: stretch;
              }
              .dashboard-footer-cols > div {
                min-width: 0 !important;
                margin-bottom: 12px;
              }
            }
            @media (max-width: 600px) {
              .dashboard-footer-main {
                padding: 18px 0 !important;
              }
              .dashboard-footer-cols {
                flex-direction: column; /* Ensure mobile columns stack */
                gap: 16px;
                margin-bottom: 18px;
                /* --- MODIFIED: Increased horizontal padding for small screens --- */
                padding: 0 16px !important;
              }
              .dashboard-footer-cols > div {
                font-size: 15px !important;
              }
              .dashboard-footer-cols > div:last-child {
                padding-bottom: 32px !important;
              }
              .dashboard-footer-bottom {
                flex-direction: column;
                gap: 6px;
                padding: 10px 16px 8px 16px !important; /* --- MODIFIED: Adjusted bottom footer padding --- */
                font-size: 12px !important;
                text-align: center;
              }
              .dashboard-footer-bottom > div {
                text-align: center !important;
              }
              /* Stack social icons vertically on mobile */
              .dashboard-footer-cols > div:nth-child(3) > div:last-child {
                flex-direction: column !important;
                gap: 14px !important;
              }
              /* Reduce icon sizes further on very small screens */
              .footer-link-icon {
                font-size: 18px !important;
              }
              img[alt="X (Twitter)"] {
                width: 18px !important;
                height: 18px !important;
              }
            }
            @media (max-width: 480px) {
              .dashboard-footer-cols {
                padding: 0 16px !important;
              }
              .dashboard-footer-bottom {
                padding: 8px 0 6px 0 !important;
              }
              .dashboard-footer-main {
                padding: 16px 0 !important;
              }
              .footer-link {
                font-size: 14px !important;
              }
              .footer-link-icon {
                font-size: 16px !important;
              }
              img[alt="X (Twitter)"] {
                width: 16px !important;
                height: 16px !important;
              }
            }
            @media (max-width: 768px) {
              footer {
                margin-left: -16px !important;
                margin-right: -16px !important;
                width: calc(100% + 32px) !important;
              }
            }
            .footer-link {
              color: #111 !important;
              text-decoration: none !important;
              transition: color 0.2s;
            }
            .footer-link-icon {
              color: #111 !important;
              transition: color 0.2s;
            }
            .footer-link:hover, .footer-link:focus {
              color: #00b050 !important;
            }
            .footer-link:hover .footer-link-icon, .footer-link:focus .footer-link-icon {
              color: #00b050 !important;
            }
          `}</style>
      </div>
      <div className="dashboard-footer-bottom" style={{
        width: '100%',
        background: `url(${footerbg}) repeat, #fff`,
        color: '#888',
        fontSize: 'clamp(12px, 3vw, 14px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
        // Use narrower default horizontal padding so content doesn't push off-screen
        padding: '12px 16px 10px 16px',
        marginTop: 0,
        boxSizing: 'border-box'
      }}>
        <div className="dashboard-footer-bottom-inner" style={{ width: '100%', maxWidth: 1200, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '0 32px', boxSizing: 'border-box' }}>
          <div style={{ textAlign: 'left', flex: '0 0 auto', minWidth: 0 }}>
            © Copyright Old Mutual Limited {new Date().getFullYear()}
          </div>
          <div style={{ textAlign: 'right', flex: '0 0 auto', minWidth: 0 }}>
            This Old Mutual Limited is a Licensed Financial Services Provider.
          </div>
        </div>
      </div>

      <style>{`
        /* Ensure footer bottom children can shrink and stay inline on large screens */
        .dashboard-footer-bottom-inner > div {
          min-width: 0;
          flex: 0 0 auto;
        }

        @media (max-width: 600px) {
          .dashboard-footer-bottom {
            padding: 10px 16px 8px 16px !important;
          }
          .dashboard-footer-bottom-inner {
            flex-direction: column;
            gap: 6px;
          }
          .dashboard-footer-bottom-inner > div {
            flex: 1 1 100%;
            text-align: center !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default DashboardFooter;